import { Routes } from '@angular/router';
import { LoginPageComponent } from './features/login/login-page/login-page.component';
import { RecuperarSenhaComponent } from './features/login/recuperar-senha/recuperar-senha.component';
import { RedefinirSenhaComponent } from './features/login/redefinir-senha/redefinir-senha.component';
import { HomePageComponent } from './features/home-page/home-page.component';
import { PerfilComponent } from './features/perfil/components/perfil.component';
import { authGuard } from './core/guards/auth.guard';
import { UsersComponent } from './features/users/components/users.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { PermissoesComponent } from './features/permissoes/components/permissoes/permissoes.component';
import { AlterarSenhaComponent } from './features/login/alterar-senha/alterar-senha.component';
import { CargosListaComponent } from './features/permissoes/components/cargos-lista/cargos-lista.component';
import { ConsultoresListaComponent } from './features/consultores/components/consultores-lista/consultores-lista.component';
import { ConsultoresDetalheComponent } from './features/consultores/components/consultores-detalhe/consultores-detalhe.component';
import { RoteirosListaComponent } from './features/roteirizacao/lista/roteiros-lista.component';
import { RoteirizacaoWizardComponent } from './features/roteirizacao/wizard/wizard.component';
import { roteirizacaoWizardRoutes } from './features/roteirizacao/wizard/wizard.routes';
import { RoteiroWizardStore } from './features/roteirizacao/wizard/wizard.store';
import { wizardResolver, newRoteiroResolver } from './features/roteirizacao/wizard/wizard.resolver';
import { CicloListaComponent } from './features/ciclo-visitacao/ciclo-lista/ciclo-lista.component';
import { CicloStepComponent } from './features/ciclo-visitacao/ciclo/steps/ciclo-step.component';
import { cicloWizardRoutes } from './features/ciclo-visitacao/ciclo/steps/ciclo-step.routes';
import { CicloWizardStore } from './features/ciclo-visitacao/ciclo/steps/ciclo-step.store';

import { FormulariosWizardStore } from './features/formularios/wizard/formularios-wizard.store';
import { formulariosWizardRoutes } from './features/formularios/wizard/formularios-wizard.routes';
import { SystemSettingsComponent } from './features/system-settings/system-settings.component';
import { AppConfigurationComponent } from './features/app-configuration/app-configuration.component';
import { pendingChangesGuard } from './core/guards/pending-changes.guard';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dash',
    pathMatch: 'full',
  },
  {
    path: '',
    component: HomePageComponent,
    children: [
      {
        path: 'dash',
        component: PerfilComponent,
        canActivate: [authGuard],
      },
      {
        path: 'administracao',
        component: UsersComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.Users.List'],
            redirectTo: 'dash',
          },
        },
      },
      {
        path: 'cargos',
        component: CargosListaComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.Roles.List'],
            redirectTo: 'dash',
          },
        },
      },
      {
        path: 'cargos/permissoes',
        component: PermissoesComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.Roles.Create'],
            redirectTo: 'cargos',
          },
        },
      },
      {
        path: 'cargos/permissoes/:id',
        component: PermissoesComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.Roles.UpdatePermissions'],
            redirectTo: 'cargos',
          },
        },
      },
      {
        path: 'perfil',
        component: PerfilComponent,
        canActivate: [authGuard],
      },
      {
        path: 'consultores',
        component: ConsultoresListaComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.Consultants.List'],
            redirectTo: 'dash',
          },
        },
      },
      {
        path: 'consultores/detalhes/:id',
        component: ConsultoresDetalheComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.Consultants.List'],
            redirectTo: 'consultores',
          },
        },
      },
      {
        path: 'ciclos-visita',
        component: CicloListaComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.VisitPlans.List'],
            redirectTo: 'dash',
          },
        },
      },
      {
        path: 'ciclos-visita/novo',
        component: CicloStepComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.VisitPlans.Create'],
            redirectTo: 'ciclos-visita',
          },
        },
        providers: [CicloWizardStore],
        children: cicloWizardRoutes,
      },
      {
        path: 'ciclos-visita/editar/:id',
        component: CicloStepComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.VisitPlans.Update'],
            redirectTo: 'ciclos-visita',
          },
        },
        providers: [CicloWizardStore],
        children: cicloWizardRoutes,
      },
      {
        path: 'roteirizacao',
        component: RoteirosListaComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.VisitPlans.List'],
            redirectTo: 'dash',
          },
        },
      },
      {
        path: 'roteirizacao/novo',
        component: RoteirizacaoWizardComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.VisitPlans.Create'],
            redirectTo: 'roteirizacao',
          },
        },
        providers: [RoteiroWizardStore],
        resolve: { reset: newRoteiroResolver },
        children: roteirizacaoWizardRoutes,
      },
      {
        path: 'roteirizacao/editar/:id',
        component: RoteirizacaoWizardComponent,
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: ['Permissions.VisitPlans.Update'],
            redirectTo: 'roteirizacao',
          },
        },
        providers: [RoteiroWizardStore],
        resolve: { data: wizardResolver },
        children: roteirizacaoWizardRoutes,
      },
      {
        path: 'formularios',
        loadComponent: () => import('./features/formularios/lista/formularios-lista.component').then(m => m.FormulariosListaComponent),
        canActivate: [authGuard],
      },
      {
        path: 'formularios/novo',
        loadComponent: () => import('./features/formularios/wizard/formularios-wizard.component').then(m => m.FormulariosWizardComponent),
        canActivate: [authGuard],
        providers: [FormulariosWizardStore],
        children: formulariosWizardRoutes,
      },
      {
        path: 'formularios/editar/:id',
        loadComponent: () => import('./features/formularios/wizard/formularios-wizard.component').then(m => m.FormulariosWizardComponent),
        canActivate: [authGuard],
        providers: [FormulariosWizardStore],
        children: formulariosWizardRoutes,
      },
      {
        path: 'notificacoes/push',
        loadComponent: () => import('./features/notifications/push/push-sent-list.component').then(m => m.PushSentListComponent),
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            // only: ['PushNotifications.List'],
            redirectTo: 'dash',
          },
        },
      },
      {
        path: 'notificacoes/push/nova',
        loadComponent: () => import('./features/notifications/push/push-form.component').then(m => m.PushFormComponent),
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            // only: ['PushNotifications.Create'],
            redirectTo: 'notificacoes/push',
          },
        },
      },
      {
        path: 'notificacoes/push/agendadas',
        loadComponent: () => import('./features/notifications/push/push-scheduled-list.component').then(m => m.PushScheduledListComponent),
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            // only: ['PushNotifications.List'],
            redirectTo: 'notificacoes/push',
          },
        },
      },
      {
        path: 'notificacoes/push/agendadas/:id/editar',
        loadComponent: () => import('./features/notifications/push/push-form.component').then(m => m.PushFormComponent),
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            // only: ['PushNotifications.Update'],
            redirectTo: 'notificacoes/push/agendadas',
          },
        },
      },
      {
        path: 'notificacoes/in-app',
        loadComponent: () => import('./features/notifications/in-app/in-app-list.component').then(m => m.InAppListComponent),
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            // only: ['InAppNotifications.List'],
            redirectTo: 'dash',
          },
        },
      },
      {
        path: 'notificacoes/in-app/nova',
        loadComponent: () => import('./features/notifications/in-app/in-app-form.component').then(m => m.InAppFormComponent),
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            // only: ['InAppNotifications.Create'],
            redirectTo: 'notificacoes/in-app',
          },
        },
      },
      {
        path: 'notificacoes/in-app/:id/editar',
        loadComponent: () => import('./features/notifications/in-app/in-app-form.component').then(m => m.InAppFormComponent),
        canActivate: [authGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            // only: ['InAppNotifications.Update'],
            redirectTo: 'notificacoes/in-app',
          },
        },
      },
      {
        path: 'relatorios',
        redirectTo: 'relatorios/produtividade',
        pathMatch: 'full',
      },
      {
        path: 'relatorios/produtividade',
        loadComponent: () =>
          import('./features/relatorios/produtividade-dashboard/produtividade-dashboard.component').then(
            (m) => m.ProdutividadeDashboardComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'relatorios/execucao',
        loadComponent: () =>
          import('./features/relatorios/execucao-dashboard/execucao-dashboard.component').then(
            (m) => m.ExecucaoDashboardComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'relatorios/visitacao',
        loadComponent: () =>
          import('./features/relatorios/visitacao-dashboard/visitacao-dashboard.component').then(
            (m) => m.VisitacaoDashboardComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'relatorios/roteirizacao',
        loadComponent: () =>
          import('./features/relatorios/roteirizacao-dashboard/roteirizacao-dashboard.component').then(
            (m) => m.RoteirizacaoDashboardComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'permissoes',
        component: PerfilComponent,
        canActivate: [authGuard],
      },
      {
        path: 'configuracoes-app',
        component: AppConfigurationComponent,
        canActivate: [authGuard],
        canDeactivate: [pendingChangesGuard],
      },
      {
        path: 'configuracoes',
        component: SystemSettingsComponent,
        canActivate: [authGuard],
        canDeactivate: [pendingChangesGuard],
      },
    ],
  },
  { path: 'account/login', component: LoginPageComponent },
  { path: 'account/recuperar-senha', component: RecuperarSenhaComponent },
  { path: 'account/redefinir-senha', component: RedefinirSenhaComponent },
  {
    path: 'account/alterar-senha',
    component: AlterarSenhaComponent,
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: 'dash' },
];
